export default __webpack_public_path__ + "static/media/started-logo.c41ee28d.svg";